<template>
    <div>
        <v-btn
            @click="toggleAddDialog()"
            class="info text--white"
            slot="activator"
        >Add Asset
        </v-btn>
        <v-dialog
            :value="addAssetDialog"
            max-width="500px"
            persistent
        >
            <v-card>
                <v-card-title
                    class="pt-1 pb-1 headline grey lighten-2"
                    color="primary"
                    primary-title
                >
                    <span class="headline">Add Asset</span>
                    <v-spacer />
                    <v-btn
                        @click="toggleAddDialog()"
                        fab
                        small
                        text
                    >
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex>
                                <v-select
                                    :error-messages="addAssetTypeIdErrors"
                                    :items="assetTypeList"
                                    item-text="name"
                                    item-value="assetTypeId"
                                    @blur="$v.addAssetTypeId.$touch()"

                                    @input="$v.addAssetTypeId.$touch()"
                                    label="Asset Type"
                                    v-model="addAssetTypeId"
                                />
                            </v-flex>
                            <v-flex>
                                <v-select
                                    :error-messages="addAssetStatusIdErrors"
                                    :items="assetStatusList"
                                    item-text="name"
                                    item-value="assetStatusId"
                                    @blur="$v.addAssetStatusId.$touch()"

                                    @input="$v.addAssetStatusId.$touch()"
                                    label="Asset Status"
                                    v-model="addAssetStatusId"
                                />
                            </v-flex>
                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-text-field
                                    label="Description"
                                    v-model="addDescription"
                                    :error-messages="addDescriptionErrors"
                                />
                            </v-flex>
                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-select
                                    clearable
                                    :items="livePersonnel()"
                                    item-text="name"
                                    item-value="personId"
                                    label="Personnel"
                                    v-model="addPersonId"
                                />
                            </v-flex>
                            <v-flex>
                                <v-menu
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    min-width="290px"
                                    offset-y
                                    transition="scale-transition"

                                    v-model="acquisitionDateMenu"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            :error-messages="addAcquisitionDateErrors"
                                            @blur="$v.addAcquisitionDate.$touch()"
                                            @input="acquisitionDateMenu = false && $v.addAcquisitionDate.$touch()"
                                            label="Acquisition Date"
                                            prepend-icon="event"
                                            readonly
                                            slot="activator"
                                            :value="addAcquisitionDate"
                                            v-on="on"
                                        />
                                    </template>
                                    <v-date-picker
                                        :error-messages="addAcquisitionDateErrors"
                                        @blur="$v.addAcquisitionDate.$touch()"
                                        @input="acquisitionDateMenu = false && $v.addAcquisitionDate.$touch()"
                                        no-title
                                        scrollable
                                        v-model="addAcquisitionDate"
                                    >
                                    <v-btn text color="primary" @click="() => {this.addAcquisitionDate = null}">Clear</v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>

                            <v-flex>
                                <v-menu
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    min-width="290px"
                                    offset-y
                                    transition="scale-transition"

                                    v-model="warrantyExpiryDateMenu"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            @blur="$v.addWarrantyExpiryDate.$touch()"
                                            @input="warrantyExpiryDateMenu = false && $v.addWarrantyExpiryDate.$touch()"
                                            label="Warranty Expiry Date"
                                            prepend-icon="event"
                                            readonly
                                            slot="activator"
                                            :value="addWarrantyExpiryDate"
                                            v-on="on"
                                        />
                                    </template>
                                    <v-date-picker
                                        @blur="$v.addWarrantyExpiryDate.$touch()"
                                        @input="warrantyExpiryDateMenu = false && $v.addWarrantyExpiryDate.$touch()"
                                        no-title
                                        scrollable
                                        v-model="addWarrantyExpiryDate"
                                    >
                                    <v-btn text color="primary" @click="() => {this.addWarrantyExpiryDate = null}">Clear</v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-text-field
                                    label="Cost"
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    v-model="addCost"
                                    :error-messages="addCostErrors"
                                />
                            </v-flex>
                            <v-flex>
                                <v-select
                                    :error-messages="addCurrencyIdErrors"
                                    :items="currencyList"
                                    item-text="name"
                                    item-value="id"
                                    @blur="$v.addCurrencyId.$touch()"
                                    @input="$v.addCurrencyId.$touch()"
                                    label="Currency"
                                    v-model="addCurrencyId"
                                />
                            </v-flex>
                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-text-field
                                    label="ECS Reference Code"
                                    v-model="addEcsReferenceCode"
                                    :error-messages="addEcsReferenceCodeErrors"
                                />
                            </v-flex>
                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-text-field
                                    label="Serial Number"
                                    v-model="addSerialNumber"
                                />
                            </v-flex>
                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-textarea
                                    label="Comments"
                                    v-model="addComments"
                                />
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        @click="saveNewItemAndCloseDialog"
                        color="green"
                        text
                    >
                        Save
                    </v-btn>
                    <v-btn
                        @click="closeNewItem"
                        color="red darken-1"
                        text
                    >
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import { FETCH_PERSONNEL } from "@/store/person/actions.js";
import { FETCH_PERSON_ASSET_LIST, SAVE_NEW_PERSON_ASSET } from "@/store/person_asset/actions.js";
import { RESET_DEFAULT_NEW_PERSON_ASSET, TOGGLE_NEW_PERSON_ASSET_DIALOG, UPDATE_ADD_PERSON_ASSET_FIELD } from "@/store/person_asset/mutations.js";
import { required, } from 'vuelidate/lib/validators';
import { mapActions, mapGetters, mapMutations } from "vuex";
import EditTableFunctions from './../../ManagePersonnel/components/editTableFunctions';

    export default {
        name: "AddAssetDialog",

        validations: {
            addEcsReferenceCode: {required},
            addDescription: {required},
            addAssetTypeId: {required},
            addAssetStatusId: {required},
            addAcquisitionDate: {required},
            addWarrantyExpiryDate: {required},
            addCost: {required},
            addCurrencyId: {required},
        },

        mixins: [
            EditTableFunctions,
        ],

        data: () => ({
            acquisitionDateMenu: false,
            warrantyExpiryDateMenu: false
        }),

        computed: {
            ...mapGetters(
                [
                    "assetTypeList",
                    "livePersonnel",
                    "assetStatusList",
                    "currencyList",
                ]
            ),
            addAssetDialog: {
                get() {
                    return this.$store.state.person_asset.addPersonAssetDialog;
                },
            },
            addDescription: {
                get() {
                    return this.$store.state.person_asset.addPersonAsset.description;
                },
                set(value) {
                    this.updateNewValue('description', value);
                },
            },
            addDescriptionErrors() {
                const errors = [];
                if (!this.$v.addDescription.$dirty) return errors;
                !this.$v.addDescription.required && errors.push('required.');
                return errors
            },

            addAssetTypeId: {
                get() {
                    return this.$store.state.person_asset.addPersonAsset.assetTypeId;
                },
                set(value) {
                    this.updateNewValue('assetTypeId', value);
                },
            },

            addAssetTypeIdErrors() {
                const errors = [];
                if (!this.$v.addAssetTypeId.$dirty) return errors;
                !this.$v.addAssetTypeId.required && errors.push('required.');
                return errors
            },

            addCurrencyId: {
                get() {
                    return this.$store.state.person_asset.addPersonAsset.currencyId;
                },
                set(value) {
                    this.updateNewValue('currencyId', value);
                },
            },

            addCurrencyIdErrors() {
                const errors = [];
                if (!this.$v.addCurrencyId.$dirty) return errors;
                !this.$v.addCurrencyId.required && errors.push('required.');
                return errors
            },

            addAssetStatusId: {
                get() {
                    return this.$store.state.person_asset.addPersonAsset.assetStatusId;
                },
                set(value) {
                    this.updateNewValue('assetStatusId', value);
                },
            },

            addAssetStatusIdErrors() {
                const errors = [];
                if (!this.$v.addAssetStatusId.$dirty) return errors;
                !this.$v.addAssetStatusId.required && errors.push('required.');
                return errors
            },

            addAcquisitionDate: {
                get() {
                    return this.$store.state.person_asset.addPersonAsset.acquisitionDate;
                },
                set(value) {
                    this.updateNewValue('acquisitionDate', value);
                },
            },

            addAcquisitionDateErrors() {
                const errors = [];
                if (!this.$v.addAcquisitionDate.$dirty) return errors;
                !this.$v.addAcquisitionDate.required && errors.push('required.');
                return errors
            },

            addCost: {
                get() {
                    return this.$store.state.person_asset.addPersonAsset.cost;
                },
                set(value) {
                    this.updateNewValue('cost', value);
                },
            },

            addCostErrors() {
                const errors = [];
                if (!this.$v.addCost.$dirty) return errors;
                !this.$v.addCost.required && errors.push('required.');
                return errors
            },

            addEcsReferenceCode: {
                get() {
                    return this.$store.state.person_asset.addPersonAsset.ecsReferenceCode;
                },
                set(value) {
                    this.updateNewValue('ecsReferenceCode', value);
                },
            },

            addEcsReferenceCodeErrors() {
                const errors = [];
                if (!this.$v.addEcsReferenceCode.$dirty) return errors;
                !this.$v.addEcsReferenceCode.required && errors.push('required.');
                return errors
            },

            addSerialNumber: {
                get() {
                    return this.$store.state.person_asset.addPersonAsset.serialNumber;
                },
                set(value) {
                    this.updateNewValue('serialNumber', value);
                },
            },

            addComments: {
                get() {
                    return this.$store.state.person_asset.addPersonAsset.comments;
                },
                set(value) {
                    this.updateNewValue('comments', value);
                },
            },

            addWarrantyExpiryDate: {
                get() {
                    return this.$store.state.person_asset.addPersonAsset.warrantyExpiryDate;
                },
                set(value) {
                    this.updateNewValue('warrantyExpiryDate', value);
                },
            },
            addPersonId: {
                get() {
                    return this.$store.state.person_asset.addPersonAsset.personId;
                },
                set(value) {
                    this.updateNewValue('personId', value);
                },
            }
        },

        mounted() {
            if (this.assetId !== undefined) {
                this.resetNewItemToDefault();
                this.updateNewValue('assetId', this.assetId);
                this.fetchPersonnel();
            }
        },

        methods: {
            fetchPersonnel() {
                this.$store.dispatch(FETCH_PERSONNEL);
            },
            ...mapActions({
                fetchTableList: FETCH_PERSON_ASSET_LIST,
                saveNewTableItemRecord: SAVE_NEW_PERSON_ASSET,
            }),
            //
            ...mapMutations({
                toggleAddDialog: TOGGLE_NEW_PERSON_ASSET_DIALOG,
                // loadTableItemToEdit: LOAD_PERSON_SUMMARY_TO_EDIT,
                updateTableItemToAdd: UPDATE_ADD_PERSON_ASSET_FIELD,
                resetNewItemToDefault: RESET_DEFAULT_NEW_PERSON_ASSET,
            }),
        }
    }
</script>

<style scoped>

</style>
